<template>
    <div class="homepage-footer">
        <img style="width: 375px;" src="https://resource.rcclchina.com.cn/Home/new/mobile_bottom.jpg" alt="" />
        <div class="foo-explain">
            <div class="foo-tag">
                <a href="/wz_index_contract/index" class="external">乘客票据合同及安全与保障政策</a>
                <a href="/wz_index_law/index" class="external">用户协议</a>
            </div>
            <div class="foo-tag">
                <a href="/wz_index_law_privacy/index" class="external">隐私政策</a>
                <a href="/wz_index_bill/index" class="external">游轮乘客权益法案</a>
                <a rel="nofollow" href="http://weibo.com/rcclchina" class="external">微博</a>
                <a rel="nofollow" href="https://mobile.rcclchina.com.cn/campaign/royalapp/" class="external">下载皇家APP</a>
            </div>
            <div>
                <img style="width: 140px; margin: 10px auto;" src="https://resource.rcclchina.com.cn/mobileHome/mobile_logo.png"/>
            </div>
            <div class="foo-content" style="background-color: black;">
                <div class="top">皇家加勒比游轮船务（中国）有限公司版权所有</div>
                <div class=""><a rel="nofollow" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31022102000123" class="external">沪公网安备 31022102000123</a>&emsp;|&emsp;<a rel="nofollow" href="https://beian.miit.gov.cn/" class="external">沪ICP备09065404号-1</a>  </div>
<!--                <div class=""><a href="tel:400-820-7293" class="external">客服热线：400-820-7293</a></div>-->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeBottom'
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    list-style: none;
    font-family: PingFang-SC, Microsoft YaHei, Helvetica;
    text-transform: uppercase;
}
img{
    display:block;
}

/**底部*/
.homepage-footer{
    height: 475px;
    position: relative;
    margin-bottom: 45px;
}
.homepage-footer .foo-explain{
    width: 100%;
    height:158px;
    position: absolute;
    left: 0;
    bottom:0;
    /* background:#040e19; */
}
.homepage-footer .foo-explain .foo-tag{
    padding:0 14px;
    display: flex;
    justify-content: space-around;
    font-size: 12px;
    letter-spacing: 1px;
    line-height: 36px;
    border-top: 1px solid #141e28;
}
.homepage-footer .foo-explain .foo-tag>a{
    color: #fff;
}
.homepage-footer .foo-explain .foo-content{
    text-align: center;
    color: #fff;
    box-sizing: border-box;
    height: 127px;
    padding-top: 10px;
}
.homepage-footer .foo-explain .foo-content div{
    line-height: 20px;
    font-size: 10px;
}
.homepage-footer .foo-explain .foo-content a{
    color: #fff;
}


</style>
